/**
 * **数值事件表**（2026-10-22 用户令「现在已有的数值事件全部删除，这些是你自己写的，我打算一条一条重写」
 * ⇒ 旧的十条草案已全部删除，本表按用户逐条重写）。
 *
 * **它不是另一套结构**：数值事件＝**剧情事件条目**（`PlotEventDef`）的一种**触发口径**——
 * 同样的 `steps`（媒体卡／对话／偶遇）、同样的 `choices`、同样的 `effects`/`setFlags`/`requireFlags`，
 * 只是 `trigger` 里多一个**数值门槛 ＋ 概率**。
 * 运行期它与固定剧情／时间线剧情并进同一张事件表（`GameData.FIXED_EVENTS`）。
 *
 * **触发规则（2026-10-22 用户令，已实装；2026-10-23 两道闸口径不变）**
 * 1. **时点**：每个月**执行完行程之后**，在**决策页**触发（宿主 `playOn: 'decisionEntry'`）。
 * 2. **顺序**：**在每月的影视热度榜之前**（决策页入场链：阶段审查演出 → **本表事件** → 影视热度榜 → 小助理播报）。
 * 3. **两道闸**：① **总闸**＝`GameConfig.NUMERIC_EVENT_RANK_CHANCE[咖位-1]`（Lv.1~3＝0／Lv.4＝10%／
 *   Lv.5＝20%／Lv.6＝30%／Lv.7＝40%／Lv.8~10＝50%）——决定"这个月有没有事"，每月至多一条；
 *   ② **池内抽取**＝门槛满足的事件里按 `trigger.weight` 轮盘。每月只判一次（`PlotSystem.checkPending`）。
 * 4. **可重复**：`repeatable: true` 的事件不置一次性灯，能反复上屏（黑帖那类"同一件事反复被翻出来"，
 * 2026-10-22 用户令）；限流只靠上面第 3 条 ＋ "在队里没演完不重复入队"。
 * 5. **一次性（不写 `repeatable`）＝特殊事件语义**（2026-10-26 茄子令「一次性事件不应该占重复事件的机会」）：
 *    不进两道闸——门槛满足即**必发**（走固定剧情那条全局扫描）、演完置灯不再发、不占"每月一条"名额、
 *    不稀释轮盘分母（做了分离，概率才不随进程漂移）。写"世界氛围随机事"带 `repeatable: true`，
 *    写"剧情节点"就不写——同一张表里 `repeatable` 一个字段自动分流，不用挑系统。
 *
 * **本表的两组事件（2026-10-23 起互为对照组）**
 * - **低口碑黑帖**（`NE_AIRPORT`／`NE_SHOELACE`／`NE_EXTRA`）：`require.attrMax.reputation = 300`
 *   （T1~T4 进池）；权重 2＝与夸帖镜像 ⇒ T1 黑帖占比＝T5 夸帖占比（2026-10-26 用户令「这两档的概率
 *   应该相等才合理」，旧「T1 权重 3＝越差越容易被抽中」分档口径同日废止）；效果 **口碑 −6**。
 * - **高口碑夸帖**（`NE_BOTTLE`／`NE_UMBRELLA`／`NE_DEBUTPOST`）：`require.attr.reputation = -300`
 *   （**T2 及以上**都进池，2026-10-23 用户令「高口碑事件和低口碑是对照组」）；权重 1；效果 **口碑 +6**。
 *   两组门槛**互斥**：T1 只抽黑帖、T5 只抽夸帖、T2~T4 两组同池按权重抽（1:1）。
 * - 三档边界沿用评价面五档（`GameConfig.REP_BAND_EDGES`）：T1 ≤ -301／T2~T4 -300~300／T5 ≥ 301。
 * - **高咖位事件**（`NE_FANSUBWAY`／`NE_CHARITY`／`NE_WORLDBOARD`／`NE_PAPARAZZI`／`NE_LOITER`，2026-10-23）：
 *   门槛只看 `require.rank`（6／6／7／7／8），**不看口碑**——黑红也是红；**权重按口碑分档：边缘 3／中立 6**
 *   （2026-10-26 用户令「高咖位占比所有口碑档全等＋边缘档口碑帖单条＝中立档 2 倍」）：
 *   口碑帖恒 2/条（边缘组合计 6、中立组合计 12），高咖位权重同步 1:2 ⇒
 *   **边缘池＝中立池的 1/2 缩放**——高咖位每条占比三档全等、边缘档口碑帖单条＝中立档的 2 倍。
 *   解锁累加：Lv.6 起 2 条、Lv.7 起 4 条、Lv.8 起 5 条。
 *   前三条（地铁灯箱／公益／海外大屏）是**玩家后援会**发的应援公告（`authorAvatar: 'player'`，头像＝玩家捏脸），
 *   评论区只有粉丝（只写一份 `comments`，不分档）；后两条（代拍堵门／蹲点扰民）仍是营销号，评论区按口碑三档。
 *   **发布号只有四个**（2026-10-23 用户令：「不需要设定专门发夸帖和黑帖的号，营销号都是上面立场都有的」）：
 *   吃瓜八倍镜（爆料快讯）／八卦小分队（路透偷拍）／娱乐圈扒爷（私信爆料）／圈内速报（媒体通报）
 *   ——**立场由事件决定，不由号决定**：同一个号这批骂、下批夸。
 * - **评论区按口碑分档**（`media.commentsByRep`，切法与低口碑同一套 `bandOf`）：
 *   黑帖＝T1 档深信不疑并添油加醋＋T2~T4 档将信将疑；夸帖＝T2~T4 档半信半疑（"这也能夸""镜头在呢"）
 *   ＋T5 档用 `comments` 兜底（真心夸）。**`comments` 永远写"兜底那一档"的唯一一份**，写了用不上的档就是死数据。
 * - **载体一律微博卡**（`kind: 'weibo'`：营销号博主行＋正文＋互动栏＋热评），
 * 微博无标题（`title` 不写）、正文单段、**正文要带话题**（2026-10-23 用户令：「一条话题都没有不合理」）；
 * 话题**可以放开头，但不是每条都拿事件名当开头话题**（同日用户令：「不要全都以事件名称的话题开头，别的话题是可以的」）
 * ——后援会三条以 `#%玩家名%#`（艺名话题）开头，营销号把 `#事件名#` 放句末，照真实微博的两种写法；
 * **不填 `buzz`**——数值事件的话题度按当下**名气**换算
 * （系数见 `GameConfig.NUMERIC_EVENT_BUZZ_FROM_FAME`）。
 * 正文与热评里的 `%玩家名%` 由 `plotStage.mediaBeatOf` 现替成**完整姓名**（名＋姓；2026-10-23 用户令
 * 「正文里提到的玩家角色的名字都只有名没有姓」）。旧的 `{player}`（昵称＝艺名）仍可替，但本表已不再用。
 * - **数值已定稿**（2026-10-23 用户令）：黑帖三条统一 **−6**、夸帖三条统一 **+6**（对照组等幅）。
 *
 * **怎么写一条**（照这个模板往数组里加，别的什么都不用改）：
 * ```ts
 * {
 * id: 'NE_001',
 * medium: 'media',
 * playOn: 'decisionEntry', // 决策页入场（影视热度榜之前）＝数值事件的识别口径
 * repeatable: true, // 可重复（不写＝一次性）
 * trigger: {
 * require: { // 进池门槛：全满足才参与抽签
 * attr: { reputation: -500 }, // 口碑 ≥ -500（attrMax 是上限）
 * rank: 5, // 咖位 ≥ 5
 * },
 * weight: [ // 池内权重分档写法（高咖位组即此形态：边缘 3／中立 6／T5 3；数字非其现行值）
 * { maxRep: -301, weight: 3 },
 * { maxRep: 300, weight: 1 },
 * ],
 * },
 * steps: [{
 * medium: 'media', // 主体＝媒体卡（新闻／热帖／微博）
 * media: {
 * kind: 'weibo', author: '吃瓜八倍镜', body: '…', // 不填 buzz：话题度按名气换算
 * comments: ['中档兜底的一条'],
 * commentsByRep: [ // 评论区随口碑分档（存在即覆盖 comments）
 * { maxRep: -301, comments: ['低档：深信不疑＋添油加醋'] },
 * { maxRep: 300, comments: ['中档：将信将疑'] }, // 高口碑不触发 ⇒ 不写高档评论
 * ],
 * },
 * effects: { reputation: -6 }, // 这一拍的数值 ⇒ 卡打开时同时飘白底气泡（2026-10-22 定）
 * }],
 * }
 * ```
 *
 * **要一个对话框的版本**：把某一拍写成 `medium: 'message'`（说话人是 `npcId`，小助理写 `npc_assistant`），
 * 配 `choices`（带 `reply`/`effects`/`setFlags`）——那一拍的数值变化会画在 VN 卡上（不飘气泡）。
 */
import type { PlotEventDef } from '../types';

/**
 * 低口碑黑帖三条（第一批：机场黑脸／助理系鞋带／群演爆料），**全部可重复**。
 * 触发＝**咖位总闸**（`GameConfig.NUMERIC_EVENT_RANK_CHANCE`）＋**池内权重**（本表 `trigger.weight`）；
 * 三条共用 `require.attrMax.reputation = 300`（高口碑不进池），权重 2＝与夸帖镜像（2026-10-26 用户令）。
 * 三条都是一拍：微博卡打开 ＋ 白底气泡数值，无对话框。
 * **效果定数（2026-10-23 用户令）：三条统一 口碑 −6**——黑帖的分量靠"频率＋口碑档位"体现，
 * 不靠单条罚得更狠；后续会补「加口碑」的数值事件，正负两条线一起攒口碑。
 */

// ===== 评论档常量（六条数值事件共用；**一律写在这里**，事件里只做引用）=====
// 命名＝`<事件>_<档>`：LOW＝T1（≤ -301）／MID＝T2~T4（-300~300）／HIGH＝T5（≥ 301）。
// 每条事件只写它**进池区间覆盖到的那几档**；`comments` 放**最高档**那条数组当兜底，
// 其余档写进 `commentsByRep`（切档走 `core/RepBands.bandOf`，全库一处判定）。
// **后援会三条**（粉丝只会关注后援会）不分档：只有一份 `comments`，不写 `commentsByRep`。
// 每档最多 3 条（卡片楼层上限），一条一个立场；允许跑题和阴阳（2026-10-23 文案口径）。

/** 机场黑脸｜低口碑 T1（深信不疑＋添油加醋） */
const AIRPORT_LOW = [
 '%玩家名%的机场黑脸又不是头一回了，去年接机也是这张脸，粉丝能不能醒醒',
 '粉丝蹲三个小时 图什么呢',
 '这不就是耍大牌吗，别洗了',
];
/** 机场黑脸｜中口碑 T2~T4（一信一疑一观望） */
const AIRPORT_MID = [
 '看表情确实是不太耐烦，不过也就一瞬间，说黑脸有点过',
 '换谁被怼着拍都不舒服',
 '有完整视频吗',
];

/** 助理系鞋带｜低口碑 T1（深信不疑＋添油加醋） */
const SHOELACE_LOW = [
 '自己没长手吗？这是把工作人员当丫鬟使吧',
 '系完抬脚就走 连句谢谢都没有',
 '这行是不是都这样',
];
/** 助理系鞋带｜中口碑 T2~T4（一信一疑一观望） */
const SHOELACE_MID = [
 '让人蹲地上系鞋带，看着是有点那个',
 '片场鞋不好弯腰，助理顺手系一下，别想太多',
 '一张图能看出什么，前因后果呢',
];

/** 群演爆料｜低口碑 T1（深信不疑＋添油加醋） */
const EXTRA_LOW = [
 '她本来就这种人啊，一点都不意外',
 '对下面什么态度 一目了然',
 '我朋友也在这个组，说法一模一样',
];
/** 群演爆料｜中口碑 T2~T4（一信一疑一观望） */
const EXTRA_MID = [
 '一个群演敢站出来说话，多少有点可信吧',
 '没图没录音，这种我一天能看到十条',
 '有锤了再说',
];

// ===== 高口碑夸帖（2026-10-23，与上面三条黑帖互为对照组）=====
// 评论口径＝低口碑那套的镜像：`comments` 写 T5（兜底那一档＝真心夸），
// `commentsByRep` 只写 T2~T4 一档（半信半疑），两档切换仍走 `bandOf`。

/** 把瓶子带下台｜中口碑（T2~T4） */
const BOTTLE_MID = [
 '这也能夸',
 '捡个瓶子而已',
 '别的不说 动作挺顺手',
];
/** 把瓶子带下台｜高口碑（T5） */
const BOTTLE_HIGH = [
 '她一直这样啊 剧组杀青也是自己收',
 '不是大事，但真没几个人做',
 '救命。。。几个瓶子也值得发一条',
];

/** 把伞递给粉丝｜中口碑（T2~T4） */
const UMBRELLA_MID = [
 '镜头在呢',
 '助理不是有伞吗',
 '先别感动，看看平时对工作人员什么态度',
];
/** 把伞递给粉丝｜高口碑（T5） */
const UMBRELLA_HIGH = [
 '去年也这样 那会儿还没这么红',
 '伞是小事 跑那两步不是',
 '她嘴笨，不会说就只会做',
];

/** 素人时期微博被扒｜中口碑（T2~T4） */
const DEBUT_MID = [
 '翻旧微博这套没什么意思',
 '素人时期谁不是这样',
 '人是会变的',
];
/** 素人时期微博被扒｜高口碑（T5） */
const DEBUT_HIGH = [
 '那时候她连个助理都没有',
 '这么多年 一点没变',
 '我要去把那条翻出来点个赞',
];

// ===== 高咖位事件（2026-10-23，越火越多）=====
// 门槛只看 `rank`，不看口碑。**权重按口碑分档：边缘 3／中立 6**（2026-10-26 用户令）：
// 口碑帖恒 2/条（边缘组合计 6、中立组合计 12），高咖位同步 1:2 ⇒ 边缘池＝中立池的 1/2 缩放——
// 高咖位每条占比三档全等、边缘档口碑帖单条＝中立档 2 倍。
// "咖位越大，事越多"由门槛长出来（Lv.6 起 2 条 → Lv.7 起 4 条 → Lv.8 起 5 条）。
// 前三条是**玩家后援会**发的应援公告（`authorAvatar: 'player'`，头像＝玩家捏脸），评论区只有粉丝，
// 所以**不分档**：只有一份 `comments`（粉丝不会因为口碑变差就集体倒戈，最多是催、是劝）。

/** 地铁灯箱应援｜后援会（粉丝评论，不分档） */
const FANSUBWAY_FANS = [
 '路过看到了 美美的很安心',
 '这组图选得真好',
 '管理组辛苦了~',
];

/** 公益应援｜后援会（粉丝评论，不分档） */
const CHARITY_FANS = [
 '等一个图书室返图',
 '这个我捐了',
 '这比什么都好',
];

/** 海外大屏应援｜后援会（粉丝评论，不分档） */
const WORLDBOARD_FANS = [
 '有排面 时差党蹲个录屏',
 '真的走出去了',
 '海外站的图一直很稳',
];

/** 代拍堵门｜低口碑 T1 */
const PAPARAZZI_LOW = [
 '代拍不就是团队养的',
 '自己买的热搜吧',
 '装什么受害者',
];
/** 代拍堵门｜中口碑 T2~T4 */
const PAPARAZZI_MID = [
 '代拍真的该管管了',
 '上次机场也这样',
 '别买图就行',
];
/** 代拍堵门｜高口碑 T5 */
const PAPARAZZI_HIGH = [
 '代拍不是粉丝 别混为一谈',
 '看着都替她累',
 '希望安保跟上',
];

/** 蹲点扰民｜低口碑 T1 */
const LOITER_LOW = [
 '追星追成这样',
 '剧组被拖累也是活该',
 '这不叫应援',
];
/** 蹲点扰民｜中口碑 T2~T4 */
const LOITER_MID = [
 '餐车也不能送吗',
 '确实有点过了',
 '已经在劝了',
];
/** 蹲点扰民｜高口碑 T5 */
const LOITER_HIGH = [
 '别给她添麻烦',
 '这种应援真没必要',
 '管理组尽快劝一下',
];

export const NUMERIC_EVENTS: PlotEventDef[] = [
 // ===== ① 机场黑脸 =====
 {
 id: 'NE_AIRPORT',
 medium: 'media',
 playOn: 'decisionEntry',
 repeatable: true,
 trigger: {
 // 高口碑（T5，>300）不进池：口碑好的人摊上这种事，没人信（2026-10-22 用户令）
 require: { attrMax: { reputation: 300 } },
 // 权重 2＝与夸帖镜像：T1 黑帖占比＝T5 夸帖占比（2026-10-26 用户令）
 weight: 2,
 },
 steps: [{
 medium: 'media',
 media: {
 kind: 'weibo',
 author: '吃瓜八倍镜',
 body: '粉丝在机场一路小跑把信递上去，换来的是%玩家名%从头到尾没抬过头，手一伸，信就进了助理包里，临了那个表情你们自己品。#%玩家名% 机场黑脸#',
 comments: AIRPORT_MID,
 commentsByRep: [
 { maxRep: -301, comments: AIRPORT_LOW },
 ],
 },
 effects: { reputation: -6 },
 }],
 },

 // ===== ② 助理系鞋带 =====
 {
 id: 'NE_SHOELACE',
 medium: 'media',
 playOn: 'decisionEntry',
 repeatable: true,
 trigger: {
 require: { attrMax: { reputation: 300 } },
 weight: 2,
 },
 steps: [{
 medium: 'media',
 media: {
 kind: 'weibo',
 author: '吃瓜八倍镜',
 body: '#%玩家名%#片场休息十来分钟，助理蹲在地上给她系鞋带，'
 + '%玩家名%低头刷手机，一句话没说，系完抬脚就走。助理看着也就二十出头。这画面你看着舒服吗？#%玩家名% 助理#',
 comments: SHOELACE_MID,
 commentsByRep: [
 { maxRep: -301, comments: SHOELACE_LOW },
 ],
 },
 effects: { reputation: -6 },
 }],
 },

 // ===== ③ 群演爆料 =====
 {
 id: 'NE_EXTRA',
 medium: 'media',
 playOn: 'decisionEntry',
 repeatable: true,
 trigger: {
 require: { attrMax: { reputation: 300 } },
 weight: 2,
 },
 steps: [{
 medium: 'media',
 media: {
 kind: 'weibo',
 author: '娱乐圈扒爷',
 body: '#%玩家名%#收到一条私信，来自某古装剧组的群演。原话：「%玩家名%对着投资方笑，'
 + '转头对我们就爱答不理，递水都懒得看一眼。」'
 + '图不放，怕被认出来。真假自辨，我只负责转。#群演爆料#',
 comments: EXTRA_MID,
 commentsByRep: [
 { maxRep: -301, comments: EXTRA_LOW },
 ],
 },
 effects: { reputation: -6 },
 }],
 },

 // ===== ④ 把瓶子带下台（高口碑对照组，2026-10-23）=====
 {
 id: 'NE_BOTTLE',
 medium: 'media',
 playOn: 'decisionEntry',
 repeatable: true,
 trigger: {
 // T2 及以上（口碑 ≥ -300）都进池；T1 只抽黑帖 ⇒ 两组门槛互斥
 require: { attr: { reputation: -300 } },
 weight: 2,
 },
 steps: [{
 medium: 'media',
 media: {
 kind: 'weibo',
 author: '八卦小分队',
 body: '#%玩家名%#品牌活动散场，工作人员上台收水，她脚边三个空瓶已经拎手里了，一路拎到后台才扔。后排观众手机拍的，画质很糊。',
 comments: BOTTLE_HIGH,
 commentsByRep: [
 { maxRep: 300, comments: BOTTLE_MID },
 ],
 },
 effects: { reputation: 6 },
 }],
 },

 // ===== ⑤ 把伞递给粉丝（高口碑对照组）=====
 {
 id: 'NE_UMBRELLA',
 medium: 'media',
 playOn: 'decisionEntry',
 repeatable: true,
 trigger: {
 require: { attr: { reputation: -300 } },
 weight: 2,
 },
 steps: [{
 medium: 'media',
 media: {
 kind: 'weibo',
 author: '娱乐圈扒爷',
 body: '#%玩家名%#收到一条私信，昨天散场下大雨。她把手里的伞隔着护栏塞给最前面那个姑娘，自己淋着上车了。发信人说不是粉丝，只是路过。',
 comments: UMBRELLA_HIGH,
 commentsByRep: [
 { maxRep: 300, comments: UMBRELLA_MID },
 ],
 },
 effects: { reputation: 6 },
 }],
 },

 // ===== ⑥ 素人时期微博被扒（高口碑对照组）=====
 {
 id: 'NE_DEBUTPOST',
 medium: 'media',
 playOn: 'decisionEntry',
 repeatable: true,
 trigger: {
 require: { attr: { reputation: -300 } },
 weight: 2,
 },
 steps: [{
 medium: 'media',
 media: {
 kind: 'weibo',
 author: '吃瓜八倍镜',
 body: '翻到%玩家名%出道前的微博，那会儿粉丝不到两百。排练到十一点没赶上末班车、食堂排骨涨了五毛、转发的抽奖一次没中。最新一条停在四年前。#%玩家名% 考古#',
 comments: DEBUT_HIGH,
 commentsByRep: [
 { maxRep: 300, comments: DEBUT_MID },
 ],
 },
 effects: { reputation: 6 },
 }],
 },

 // ===== ⑦ 地铁灯箱应援（高咖位组，2026-10-23）=====
 {
 id: 'NE_FANSUBWAY',
 medium: 'media',
 playOn: 'decisionEntry',
 repeatable: true,
 trigger: {
 // 一线起（Lv.6）：应援开始有"排面"的量级
 require: { rank: 6 },
 weight: [
 { maxRep: -301, weight: 3 },
 { maxRep: 300, weight: 6 },
 { maxRep: 500, weight: 3 },
 ],
 },
 steps: [{
 medium: 'media',
 media: {
 kind: 'weibo',
 author: '%玩家名%后援会',
 // 后援会官方号：头像＝玩家本人捏脸（2026-10-23 用户令）
 authorAvatar: 'player',
 body: '#%玩家名%# 【地铁灯箱】她会在你每天经过的那条通道里。抬头看一眼就好。请查收。',
 // 评论区只有粉丝（只看后援会的人），不分档
 comments: FANSUBWAY_FANS,
 },
 effects: { fame: 20, reputation: 1 },
 }],
 },

 // ===== ⑧ 公益应援（高咖位组，Lv.7）=====
 {
 id: 'NE_CHARITY',
 medium: 'media',
 playOn: 'decisionEntry',
 repeatable: true,
 trigger: {
 // 顶流起（Lv.7）：粉丝应援开始往"能留下点什么"的方向走
 require: { rank: 7 },
 weight: [
 { maxRep: -301, weight: 3 },
 { maxRep: 300, weight: 6 },
 { maxRep: 500, weight: 3 },
 ],
 },
 steps: [{
 medium: 'media',
 media: {
 kind: 'weibo',
 author: '%玩家名%后援会',
 authorAvatar: 'player',
 body: '#%玩家名%# 【公益】图书室的书到了。会有孩子替我们，把她的名字念出来。谢谢每一位。',
 comments: CHARITY_FANS,
 },
 effects: { fame: 12, reputation: 3 },
 }],
 },

 // ===== ⑨ 海外大屏应援（高咖位组）=====
 {
 id: 'NE_WORLDBOARD',
 medium: 'media',
 playOn: 'decisionEntry',
 repeatable: true,
 trigger: {
 // 国民女神（Lv.8）起：够得上海外应援
 require: { rank: 8 },
 weight: [
 { maxRep: -301, weight: 3 },
 { maxRep: 300, weight: 6 },
 { maxRep: 500, weight: 3 },
 ],
 },
 steps: [{
 medium: 'media',
 media: {
 kind: 'weibo',
 author: '%玩家名%后援会',
 authorAvatar: 'player',
 body: '#%玩家名%# 【海外大屏】时差挡不住喜欢。大洋那头，也有灯为她亮着。世界很大，我们陪你走远一点。请查收。',
 comments: WORLDBOARD_FANS,
 },
 effects: { fame: 50 },
 }],
 },

 // ===== ⑩ 代拍堵门（高咖位组·负面）=====
 {
 id: 'NE_PAPARAZZI',
 medium: 'media',
 playOn: 'decisionEntry',
 repeatable: true,
 trigger: {
 // 顶流起（Lv.7）：代拍才值得蹲一整天
 require: { rank: 7 },
 weight: [
 { maxRep: -301, weight: 3 },
 { maxRep: 300, weight: 6 },
 { maxRep: 500, weight: 3 },
 ],
 },
 steps: [{
 medium: 'media',
 media: {
 kind: 'weibo',
 author: '八卦小分队',
 body: '#%玩家名% 代拍#代拍把侧门和车库全堵了，安保被挤到墙角，车挪了十几分钟才出去。上车前她一直低着头。谁放这些人进来的？',
 comments: PAPARAZZI_HIGH,
 commentsByRep: [
 { maxRep: -301, comments: PAPARAZZI_LOW },
 { maxRep: 300, comments: PAPARAZZI_MID },
 ],
 },
 effects: { fame: 12, reputation: -2 },
 }],
 },

 // ===== ⑪ 蹲点扰民（高咖位组·负面）=====
 {
 id: 'NE_LOITER',
 medium: 'media',
 playOn: 'decisionEntry',
 repeatable: true,
 trigger: {
 // 一线起（Lv.6）：刚有站姐和餐车跟组
 require: { rank: 6 },
 weight: [
 { maxRep: -301, weight: 3 },
 { maxRep: 300, weight: 6 },
 { maxRep: 500, weight: 3 },
 ],
 },
 steps: [{
 medium: 'media',
 media: {
 kind: 'weibo',
 author: '圈内速报',
 body: '#%玩家名% 蹲守#据网友反映，%玩家名%的粉丝在片场门口送餐车并蹲守至凌晨，物业今日已上门投诉。剧组工作人员称会影响拍摄进度。餐车经后援会联系退回，目前人员尚未散去。',
 comments: LOITER_HIGH,
 commentsByRep: [
 { maxRep: -301, comments: LOITER_LOW },
 { maxRep: 300, comments: LOITER_MID },
 ],
 },
 effects: { fame: 8, reputation: -3 },
 }],
 },
];
